
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {

    apiKey: "AIzaSyCbKYK2oK1rR0qISwCBIBfw5hIo1JoqjXo",
  authDomain: "abhi-9bd8f.firebaseapp.com",
  
  projectId: "abhi-9bd8f",
  storageBucket: "abhi-9bd8f.firebasestorage.app",
  messagingSenderId: "95918928552",
  appId: "1:95918928552:web:731d54e9735a264853c89d",
  measurementId: "G-XEJRVH85B0"
};

const firebaseApp = initializeApp(firebaseConfig);

let messaging = null;
let swRegistration = null;

// ✅ Initialize messaging only if supported
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(firebaseApp);
    console.log("Firebase Messaging is supported & initialized.");
  } else {
    console.warn("Firebase Messaging is not supported in this browser.");
  }
});

export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      swRegistration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js"
      );
      console.log("Service Worker registered:", swRegistration);
      return swRegistration;
    } catch (error) {
      console.error("Service Worker registration failed:", error);
      throw error;
    }
  } else {
    console.error("Service workers not supported in this browser.");
    return null;
  }
};

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    console.log("Notification Permission:", permission);
    return permission;
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    return null;
  }
};

export const getFcmToken = async () => {
  if (!messaging) {
    console.warn("Messaging not initialized (unsupported browser).");
    return null;
  }

  if (!swRegistration) {
    console.warn("Service worker not registered yet, registering now...");
    await registerServiceWorker();
  }

  try {
    const token = await getToken(messaging, {
      vapidKey:
        // "BF8mLEto4bEgrsmQRswIa_pF6QWuyJrUpt6bH8e5-qubByhCWhv7bcyaexsLNHk-x2ZpujcJvxQnF_AMzZBQg3A",
        // "BCgPuYvagG_whhsSzzzfnswiZdx0MlueckaySgzhsNguxw7CP6NcgweNJtJmkYWzHTDziiIgXAXvNdOkfQ_Hh54",
        "BKN8DIyEPDG2BeKYkf8lgOKaAlDY-ofi0NWH1EgFKqtbyksPcN3zxo-KEZJEucvnXjxxI3c3qwkyGdjdiEuCVSs",
      serviceWorkerRegistration: swRegistration,
    });

    if (token) {
      console.log("FCM Token:", token);
      return token;
    } else {
      console.warn("No registration token available.");
      return null;
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null;
  }
};

export const setupForegroundMessaging = () => {
  if (!messaging) {
    console.warn("Messaging not initialized (unsupported browser).");
    return;
  }

  console.log("Setting up foreground messaging...");

  onMessage(messaging, (payload) => {
    console.log("Foreground message received:", payload);

    const title =
      payload.notification?.title || payload.data?.title || "Notification";
    const options = {
      body:
        payload.notification?.body ||
        payload.data?.body ||
        "You have a new message.",
      icon: "/icon.png",
    };

    if (Notification.permission === "granted") {
      new Notification(title, options);
    } else {
      console.warn(
        "Notification not shown — permission:",
        Notification.permission
      );
    }
  });
};
